import React from 'react'
import Main from '../components/DepartmentPage/Main'

const DeparmentPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default DeparmentPage